import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Recipient from './component';

const recipient = {
  id: 'markAsShipped.columns.recipient',
  defaultMessage: 'Recipient',
};

const GetName = () => {
  const intl = useIntl();

  return intl.formatMessage(recipient);
};

export default {
  id: 'mark-as-shipped-recipient',
  index: 1,
  isDragable: false,
  minWidth: 100,
  width: 150,
  nonsortable: true,
  getName: () => <GetName />,
  name: <FormattedMessage {...recipient} />,
  render: (data) => {
    return <Recipient fulfillmentPlanId={data.id} />;
  },
};
